module.exports = __webpack_public_path__ + "img/dumping.eddd458c.jpg";